import { PurchaseCredit } from "./purchase-credit.model";

export class TransactionDetail {
  purchasePriceAmount: number | undefined;
  purchaseCredits: PurchaseCredit[] = [];
  cashFromToBorrowerAmount: number | undefined;
}
